import axios from "axios";
import { ResponseContainer } from "../interfaces/RequestBase";

export const MAIN_URL = process.env.REACT_APP_MAIN_URL;
export const ALT_URL = process.env.REACT_APP_ALT_URL;

export enum P {
	RequestsList = "request/list",
	RequestUpdate = "request/upd",
	RequesGet = "request/get",
	RequestCreate = "request/create",

	TaskList = "task/list",
	TaskUpdate = "task/upd",
	TaskGet = "task/get",
	TaskCreate = "task/create",

	CommentList = "comment/list",
	CommentCreate = "comment/create",
	CommentFile = "comment/file",

	InterviewList = "interview/list",
	InterviewUpdate = "interview/upd",
	InterviewGet = "interview/get",
	InterviewCreate = "interview/create",
	InterviewDelete = "interview/del",

	LetterList = "letter/list",
	LetterUpdate = "letter/upd",
	LetterCreate = "letter/create",
	LetterDelete = "letter/del",

	LetterTemplateList = "template/list",
	LetterTemplateUpdate = "template/upd",
	LetterTemplateGet = "template/get",
	LetterTemplateCreate = "template/create",
	LetterTemplateDelete = "template/del",

	Auth = "manager/auth",
	ManagerList = "manager/list",
	CreateManager = "manager/reg",
	CheckManager = "manager/info",
	ManagerGet = "manager/get",
	ManagerUpdate = "manager/upd",
	RoleList = "manager/role",
	Logout = "manager/logout",

	CreateCandidate = "candidate/create",
	CandidateList = "candidate/list",
	Candidateget = "candidate/get",
	CandidateUpdate = "candidate/upd",

	CreateRegionCity = "region/create",
	RegionList = "region/list",
	RegionUpdate = "region/upd",
	RegionDelete = "region/del",

	VacancyList = "vacancy/list",
	VacancyGet = "vacancy/get",
	VacancyCreate = "vacancy/create",
	VacancyUpdate = "vacancy/upd",
	VacancyDelete = "vacancy/del",

	ProbationList = "probation/list",
	ProbationGet = "probation/get",
	ProbationCreate = "probation/create",
	ProbationUpdate = "probation/upd",
	ProbationDelete = "probation/del",

	SpecilizationList = "specialization/list",

	DirectionList = "direction/list",

	ResumeList = "resume/list",
	ResumeGet = "resume/get",
	ResumeCreate = "resume/create",
	ResumeUpdate = "resume/upd",
	DownloadFile = "resume/file",

	StatusList = "status/list",

	Avatar = "manager/avatar/",

	TestList = "test/list",
	TestCreate = "test/create",
	TestGet = "test/get",
	TestUpdate = "test/upd",
	TestDelete = "test/del",
	TestsUser = "test/user",
	ApproveTest = "test/approved",
}

async function request<R>(
	url: string,
	inData: any,
	callback?: any,
	headers?: any
) {
	axios
		.post(MAIN_URL + url, inData, { withCredentials: true, headers: headers })
		.then((response) => {
			callback(response.data as ResponseContainer<R>);
		})
		.catch(function (error) {
			callback({ status: "error", message: error } as ResponseContainer<R>);
		});
}

export default request;
